import { masterServiceBaseUrl } from "services/http"
import { endpoint } from "../../../../manage/common/constant"
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../manage/common/utils/methods/commonMethods/utilityMethod"
export const getDropdowns = async (setDropdowns) => {
    return await Promise.all([
        dropdownMapping(endpoint.businessArea.getAllActiveV2, "businessAreaDispValue", 'id', 'businessAreaDesc'),
        dropdownMapping(endpoint.term.getAllActive, "termDispValue", 'id'),
        // dropdownMapping(endpoint.course.courseIds, "businessAreaDispValue", 'id', 'businessAreaDesc'),
        // dropdownMapping(endpoint.course.courseIds, "businessAreaDispValue", 'id', 'businessAreaDesc'),
        
    ])
}

export const searchExamReceipt=async(req={}, page=0)=>{
    console.log(req)
    try{
        const res= await fetchAllPostPromisedData(`${endpoint.examCharges.search}?offset=${page}`,req);
        if(res?.code==200){
            return res
        }
    }
    catch(err){
        console.log(err)
    }
}

export const getTermDateByTermId= async(termMappingId)=>{
    try{
        const res= await fetchAllPromisedData(`${masterServiceBaseUrl}/termDateMaster/getTermDateByTermMapping/${termMappingId}`,true);
        if(res?.code==200){
            console.log(res?.data)
            return {
               termStartDate: res?.data?.[0]?.termStartDate,
               termEndDate: res?.data?.[0]?.termEndDate
            }
           
        }
    }
    catch(err){
        console.log(err)
    }
}
export const getCourseIdByBuAndTerm= async(businessAreaIds,academicTermIds)=>{
    try{
        const res= await fetchAllPostPromisedData(`${endpoint?.course?.getCourseIdByAcademicTermAndBusinessArea}`,
            {
                businessAreaIds,
                academicTermIds,
              },
              "post"
        );
        if(res?.code==200){
            return ((res?.data.filter(num => num.toString().startsWith('1'))).map((courseId) => ({
                label: courseId,
                value: courseId,
              })));
            
        }
    }
    catch(err){
        console.log(err)
    }
}

export const getExamCodeByBuAndTerm = async(req={})=>{
const res= await  fetchAllPostPromisedData(endpoint?.examCharges?.examTimeCode,req)
if(res?.code==200){
    return res?.data.map(item=>(
        {label:item, value:item}
    ))
}
}